module.exports = __webpack_public_path__ + "img/2.8cdf3e15.jpg";